/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React, { useState } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { spacing } from '../../shared/theme/spacing';
import { ticketColors } from '../../shared/theme/ticketColors';
import { modalExperience } from '../../shared/modals/modalExperience.styles';

type Props = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  /** Títulos más legibles sobre fondos oscuros (Caja y turnos). */
  brightTitle?: boolean;
};

export function CashCollapsibleSection({
  title,
  subtitle,
  children,
  defaultExpanded = false,
  brightTitle = false,
}: Props) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <View style={localStyles.root}>
      <Pressable
        onPress={() => setExpanded((v) => !v)}
        style={localStyles.header}
        accessibilityRole="button"
        accessibilityState={{ expanded }}
        accessibilityLabel={`${title}, ${expanded ? 'contraer' : 'expandir'}`}
      >
        <View style={localStyles.headerText}>
          <Text style={brightTitle ? localStyles.brightTitle : modalExperience.formSectionTitle}>{title}</Text>
          {subtitle ? (
            <Text style={localStyles.subtitle} numberOfLines={3}>
              {subtitle}
            </Text>
          ) : null}
        </View>
        <Ionicons
          name={expanded ? 'chevron-up' : 'chevron-down'}
          size={22}
          color={ticketColors.ink2}
        />
      </Pressable>
      {expanded ? <View style={localStyles.body}>{children}</View> : null}
    </View>
  );
}

const localStyles = StyleSheet.create({
  root: {
    marginTop: spacing.md,
    paddingTop: spacing.md,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.sm,
  },
  headerText: {
    flex: 1,
    minWidth: 0,
    gap: 4,
  },
  subtitle: {
    ...modalExperience.heroSubtitle,
    fontWeight: '600',
    fontSize: 13,
    color: ticketColors.ink2,
  },
  brightTitle: {
    ...modalExperience.formSectionTitle,
    color: ticketColors.ink,
  },
  body: {
    marginTop: spacing.sm,
  },
});
